var scope_0 = require('/Users/mike/src/web dev/website/gatsby-ts-site/michael-misiewicz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8f6d640349dc9d56431fd8be799c7797.js').default;export default
        Object.assign({}, scope_0 )
    